import React, { useEffect, useState } from 'react';
import { Formik, Form, FieldArray, Field } from 'formik';
import { Container, Table, Input } from "reactstrap";
import * as Yup from "yup";
import './Reports.css'
import Swal from "sweetalert2";
import { FormSelectData } from './FormSelectData';

export function Report196() {
    const [data, setData] = useState([]);
    const [meetingYear, setMeetingYear] = useState("")
    const [meetingDate, setMeetingDate] = useState("")
    const [meetingNo, setMeetingNo] = useState("")
    const selectOption = [{ id: "1", value: "หลักสูตรเฉพาะ" }, { id: "2", value: "หลักสูตรทั่วไป" }]
    const [disabledSubmit, setDisableSubmit] = useState(true)

    useEffect(() => {
        async function getData() {
            try {
                let res = await fetch(`api/BorrowReports/borrowReport196?meetingNo=${meetingNo}&meetingYear=${meetingYear}&meetingDate=${meetingDate}`)
                let resJson = await res.json();
                let newData = [];
                if (resJson.status === 1) {
                    await resJson.dataenum.forEach((item, i) => {
                        item.listTrainTests = item.listTrainTests.filter((type) => {
                            return type.trainTestId !== null
                        });
                        item.listTrainTests.sort((a, b) => a.trainTestId - b.trainTestId).forEach((trainTest, j) => {
                            if(trainTest.type === "1" && trainTest.typeCourseCode === null){
                                setDisableSubmit(false)
                            }
                            newData.push({
                                no: i + 1,
                                borrowId: item.borrowId,
                                employee: item.employee,
                                employeeAmount: item.employeeAmount,
                                trainTestId: trainTest.trainTestId,
                                courseNameTrainTest: trainTest.courseNameTrainTest,
                                classAmountTrainTest: trainTest.classAmountTrainTest,
                                personTrainTest: trainTest.personTrainTest,
                                periodTrainCourse: trainTest.periodTrainCourse,
                                type: trainTest.type,
                                typeCourseCode: trainTest?.typeCourseCode??""
                            })
                        })
                    })

                    setData(newData);
                }
            } catch (e) {
                // console.log("err =>", e)
            }
        }
        getData()
    }, [meetingNo, meetingYear, meetingDate])

    let namesArr = {};
    let resultIndex = 1;
    const mergeCell = data.reduce((result, item, key) => {
        const borrowKey = `${item.borrowId}_${item.employee}_${item.employeeAmount}`;
        // console.log("namesArr:", namesArr);
        if (namesArr[borrowKey] === undefined) {
            namesArr[borrowKey] = { index: key, count: 1 };
            result[key] = 1;
        } else {
            const firstIndex = namesArr[borrowKey].index;
            const count = namesArr[borrowKey].count;
            if (firstIndex + count === key ||
                (borrowKey === `${data[key - 1].borrowId}_${data[key - 1].employee}_${data[key - 1].employeeAmount}` && result[key - 1] === 0)
            ) {
                // console.log(`Merging cells ${firstIndex}-${firstIndex + count - 1}`);
                namesArr[borrowKey].count += 1;
                result[firstIndex] += 1;
                for (let i = firstIndex + 1; i < key; i++) {
                    result[i] = 0;
                }
            } else {
                namesArr[borrowKey] = { index: key, count: 1 };
                result[key] = 1;
            }
        }
        return result;
    }, [])

    const inititalValues = {
        typeCourseCodeAr: data?.map((item) => ({
            type: item.type,
            trainTestId: item.trainTestId,
            typeCourseCode: item?.typeCourseCode??""
        }))
    }
    const validationSchema = Yup.object().shape({
        typeCourseCodeAr: Yup.array().of(
            Yup.object().shape({
                typeCourseCode: Yup.string().when("type", {
                    is: "1",
                    then: Yup.string().oneOf(["1", "2"]).required()
                }),
            })
        ),
    });
    const onSubmit = async (values) => {
        values.typeCourseCodeAr = values.typeCourseCodeAr.filter((type) => {
            return type.type === "1"
        })
        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await fetch("api/BorrowReports/saveTypeCourseCode", {
                        method: "POST",
                        headers: { 'Content-type': 'application/json' },
                        body: JSON.stringify(values)
                    })
                    let resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                            timer: 2000
                            // showCancelButton: true,
                            // cancelButtonText: "ยกเลิก",
                            // cancelButtonColor: "#ff0000",
                        }).then(() => {
                            window.location.reload();
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        })
                    }
                } catch (e) {
                    // console.log("err =>", e)
                }
            }
        })



    }
    // if (loading) { return <Loading /> }
    return (
        <>
            <FormSelectData
                setMeetingNo={setMeetingNo}
                setMeetingYear={setMeetingYear}
                setMeetingDate={setMeetingDate}
            />
            <Formik
                initialValues={inititalValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {() => {
                    return (
                        <Container className='my-4'>
                            <Form>
                                <div className="report-wrapper overflow-auto">
                                    <Table className="styled-table text-center" bordered>
                                        <thead className='styles-thead'>
                                            <tr>
                                                <th rowSpan="2" className='text-center'>
                                                    ลำดับ
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    ชื่อสถานประกอบกิจการ
                                                </th>
                                                <th colSpan="2" className='text-center'>
                                                    จำนวนลูกจ้าง
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    ชื่อหลักสูตร /<br /> สาขาอาชีพ
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    จำนวนรุ่น /<br /> จำนวนครั้ง
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    จำนวนผู้เข้ารับ<br />การฝึกอบรม (คน)
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    จำนวนผู้เข้ารับ<br />การทดสอบ (คน)
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    ระยะเวลา<br />ฝึกอบรม (ช.ม.)
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    ลูกจ้างได้รับการ<br />พัฒนาฝีมือแรงงาน (คน)
                                                </th>
                                                <th rowSpan="2" className='text-center'>
                                                    ประเภทหลักสูตร<br />การฝึกอบรม
                                                </th>

                                            </tr>
                                            <tr>
                                                <th className='text-center'>
                                                    ลูกจ้างต่ำกว่า 100 คน
                                                </th>
                                                <th className='text-center'>
                                                    ลูกจ้างมากกว่า 100 คน
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {data.length > 0 ? (
                                                <FieldArray name={"typeCourseCodeAr"}>
                                                    {(FieldArrayProps) => {
                                                        resultIndex = 1;
                                                        return (
                                                            <>
                                                                {data.map((item, i) => (
                                                                    <tr key={i}>
                                                                        {mergeCell[i] > 0 ? (
                                                                            <td rowSpan={mergeCell[i]} className='text-center'>{resultIndex++}</td>
                                                                        ) : null}
                                                                        {mergeCell[i] > 0 ? (
                                                                            <td rowSpan={mergeCell[i]} className='text-center'>{item.employee}</td>
                                                                        ) : null}
                                                                        {mergeCell[i] > 0 ? (
                                                                            <td rowSpan={mergeCell[i]} className='text-center'>{item.employeeAmount < 100 ? item.employeeAmount : "-"}</td>
                                                                        ) : null}
                                                                        {mergeCell[i] > 0 ? (
                                                                            <td rowSpan={mergeCell[i]} className='text-center'>{item.employeeAmount > 100 ? item.employeeAmount : "-"}</td>
                                                                        ) : null}

                                                                        <td className='text-center'>
                                                                            {item.courseNameTrainTest}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.classAmountTrainTest}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.type === "1" ? item.personTrainTest : "-"}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.type === "2" ? item.personTrainTest : "-"}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.periodTrainCourse ? item.periodTrainCourse : "-"}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.type === "2" ? item.personTrainTest : null}
                                                                            {item.type === "1" ? item.personTrainTest > item.employeeAmount ? item.employeeAmount : item.personTrainTest : null}
                                                                        </td>
                                                                        <td className='text-center'>
                                                                            {item.type === "1" ? (
                                                                                <Field name={`typeCourseCodeAr[${i}].typeCourseCode`}
                                                                                >
                                                                                    {({ field, form, meta }) => (
                                                                                        <Input
                                                                                            type="select"
                                                                                            className={meta.error && meta.touched ?
                                                                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                            {...field}
                                                                                            disabled={item.typeCourseCode !== ""}

                                                                                        >
                                                                                            <option
                                                                                                defaultValue={"กรุณาเลือกประเภทหลักสูตร"}
                                                                                            >
                                                                                                กรุณาเลือกประเภทหลักสูตร
                                                                                            </option>
                                                                                            {selectOption.map((select) => (
                                                                                                <option
                                                                                                    key={select.id}
                                                                                                    value={select.id}
                                                                                                >
                                                                                                    {select.value}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Input>
                                                                                    )}
                                                                                </Field>
                                                                            ) : "-"}

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </>
                                                        )
                                                    }}
                                                </FieldArray>

                                            ) : (
                                                <tr><td colSpan="11" className='text-center'>ไม่มีข้อมูลในระบบ</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className='d-flex justify-content-center align-items-center text-center mt-4'>
                                    <button type='submit' disabled={disabledSubmit} className='btn-blue w-25'>บันทึก</button>
                                </div>
                            </Form>
                        </Container >

                    )
                }}

            </Formik >
        </>

    )
}